
import { useRef } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEOMetadata from '@/components/SEOMetadata';
import ResidentialHeroSection from '@/components/ResidentialHeroSection';
import ResidentialPricingSection from '@/components/ResidentialPricingSection';
import ResidentialTrustSection from '@/components/ResidentialTrustSection';
import UseCasesSection from '@/components/UseCasesSection';
import FreeProxyPopup, { FreeProxyPopupRef } from '@/components/FreeProxyPopup';

const ResidentialProxies = () => {
  const freeProxyPopupRef = useRef<FreeProxyPopupRef>(null);

  const handleOpenPopup = () => {
    console.log('Opening popup form directly from header');
    freeProxyPopupRef.current?.openForm();
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Residential Proxies",
    "provider": {
      "@type": "Organization",
      "name": "NEXX TELECOM"
    },
    "description": "High-quality residential proxy services with rotating IP addresses from real residential networks. Perfect for web scraping, ad verification, and market research.",
    "serviceType": "Residential Proxy Service",
    "areaServed": "Global"
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOMetadata
        title="Residential Proxies | Rotating IP Addresses | NEXX"
        description="Premium residential proxy service with rotating IPs from real residential networks. Perfect for web scraping, ad verification, and market research. Global coverage."
        keywords="residential proxies, rotating proxies, residential IP addresses, web scraping proxies, ad verification proxies, market research proxies"
        canonical="https://nexx.net/residential-proxies"
        structuredData={structuredData}
      />
      <Header />
      <ResidentialHeroSection onOpenPopup={handleOpenPopup} />
      <ResidentialPricingSection />
      <UseCasesSection />
      <ResidentialTrustSection />
      <Footer />
      <FreeProxyPopup ref={freeProxyPopupRef} />
    </div>
  );
};

export default ResidentialProxies;
